(function () {
  class FeatureListSlider {
    constructor(section) {
      this.section = section;
      this.items = Array.from(
        section.querySelectorAll(".feature-list-slider__item")
      );
      this.images = Array.from(
        section.querySelectorAll(".feature-list-slider__image")
      );
      this.duration = parseInt(section.dataset.autoplayDuration, 10) || 4000;
      this.currentIndex = 0;
      this.timer = null;
      this.destroyed = false;
      this.userPaused = false;

      if (this.items.length < 2) return;

      this.init();
    }

    init() {
      this.items.forEach((item, index) => {
        item.addEventListener("click", () => this.onItemActivate(index));
        item.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            this.onItemActivate(index);
          }
        });
      });

      this.initToggle();

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!this.userPaused) this.start();
            } else {
              this.stop();
            }
          });
        },
        { threshold: 0.2 }
      );

      this.observer.observe(this.section);
    }

    initToggle() {
      const toggle = this.section.querySelector(
        "[data-feature-list-slider-toggle]"
      );
      if (!toggle) return;

      const pauseIcon = toggle.querySelector(
        ".video-autoplay-toggle__icon--pause"
      );
      const playIcon = toggle.querySelector(
        ".video-autoplay-toggle__icon--play"
      );

      const setToggleState = (isPlaying) => {
        toggle.setAttribute("aria-pressed", String(isPlaying));
        toggle.setAttribute(
          "aria-label",
          isPlaying ? toggle.dataset.pauseLabel : toggle.dataset.playLabel
        );
        pauseIcon.hidden = !isPlaying;
        playIcon.hidden = isPlaying;
      };

      toggle.addEventListener("click", () => {
        if (this.userPaused) {
          this.userPaused = false;
          this.start();
          setToggleState(true);
        } else {
          this.userPaused = true;
          this.stop();
          setToggleState(false);
        }
      });

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.userPaused = true;
        setToggleState(false);
      }
    }

    onItemActivate(index) {
      if (index === this.currentIndex) return;
      this.goTo(index);
      this.restart();
    }

    start() {
      if (this.timer) return;
      this.timer = setInterval(() => this.next(), this.duration);
    }

    stop() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      if (!this.userPaused) this.start();
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      this.goTo(nextIndex);
    }

    goTo(index) {
      this.currentIndex = index;

      this.items.forEach((item, i) => {
        item.classList.toggle("active", i === index);
        item.setAttribute("aria-current", i === index ? "true" : "false");
      });

      this.images.forEach((image, i) => {
        image.classList.toggle("active", i === index);
      });
    }

    destroy() {
      if (this.destroyed) return;
      this.destroyed = true;

      this.stop();
      if (this.observer) this.observer.disconnect();
    }
  }

  let instances = [];

  const initSliders = () => {
    instances.forEach((instance) => instance.destroy());
    instances = [];

    document
      .querySelectorAll(".feature-list-slider-section .feature-list-slider")
      .forEach((section) => {
        instances.push(new FeatureListSlider(section));
      });
  };

  document.addEventListener("DOMContentLoaded", initSliders);
  document.addEventListener("shopify:section:load", initSliders);
  document.addEventListener("shopify:section:unload", initSliders);
})();
